<template>
  <div>
    <v-row dense>
      <v-col xl="3" lg="3" md="3" cols="12">
        <v-list-item class="grey lighten-3 rounded-lg">
          <v-list-item-content>
            <v-list-item-subtitle>Total títulos</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold mt-1">{{
              perfil.pagamentos.qtdetitulos
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-col>
      <v-col xl="3" lg="3" md="3" cols="12">
        <v-list-item class="grey lighten-3 rounded-lg">
          <v-list-item-content>
            <v-list-item-subtitle>Pgto antecipado</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold mt-1">{{
              perfil.pagamentos.qtdeantecipado
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="font-weight-bold subtitle-1">
            {{ perfil.pagamentos.percantecipado }} %
          </v-list-item-action>
        </v-list-item>
      </v-col>
      <v-col xl="3" lg="3" md="3" cols="12">
        <v-list-item class="grey lighten-3 rounded-lg">
          <v-list-item-content>
            <v-list-item-subtitle>Pgto no vencimento</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold mt-1">{{
              perfil.pagamentos.qtdenovcto
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="font-weight-bold subtitle-1">
            {{ perfil.pagamentos.percnovcto }} %
          </v-list-item-action>
        </v-list-item>
      </v-col>
      <v-col xl="3" lg="3" md="3" cols="12">
        <v-list-item class="grey lighten-3 rounded-lg">
          <v-list-item-content>
            <v-list-item-subtitle>Pgto atrasado</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold mt-1">{{
              perfil.pagamentos.qtdeatrasado
            }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action class="font-weight-bold subtitle-1">
            {{ perfil.pagamentos.percatrasado }} %
          </v-list-item-action>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card color="grey lighten-3" rounded="lg" flat>
          <v-card-text>
            <v-data-table
              dense
              :items="perfil.pagamentos.historico"
              :headers="headers"
              no-data-text="Nenhum histórico encontrado"
              :disable-sort="isMobile()"
            >
              <template v-slot:[`item.valor`]="{ item }">
                {{ formatarMoeda(item.valor) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { formatMoeda } from "@/global";
export default {
  props: {
    perfil: Object,
  },
  data: () => ({
    headers: [
      { text: "Histórico", value: "descricao" },
      { text: "Qtde Títulos", value: "qtde" },
      { text: "Valor Títulos", value: "valor" },
    ],
  }),
  methods: {
    isMobile() {
      return this.$mq == "sm";
    },
    formatarMoeda(value) {
      return formatMoeda(value);
    },
  },
};
</script>

<style>
</style>